import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationResultMessagesComponent } from './validationResultMessages.component';
import { WaitLoadingModule } from '../waitLoading/waitLoading.module';

import { TableModule } from 'primeng-lts/table';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ValidationResultMessagesComponent],
    imports: [
        CommonModule,
        WaitLoadingModule,
        TableModule,
        TranslateModule
    ],
    exports: [ValidationResultMessagesComponent]
})

export class ValidationModule { }